'use client'

import * as React from 'react'
import ContactForm from '@/components/contact/ContactForm'

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1 container mx-auto px-4 lg:px-12 py-12 md:py-16">
        <ContactForm />
      </main>
    </div>
  )
}
